/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { useContext } from "../../../context";
import { showFormattedDate } from "../../../../../../../../../Utils";

export function LastCancelled() {
  const { appointment } = useContext();

  return (
    <div className="detail-row">
      <label>Last Cancelled Appointment:</label>
      <span>
        {appointment.lastCancelled?.date
          ? showFormattedDate(appointment.lastCancelled.date, true)
          : "Never"}
      </span>
    </div>
  );
}
